<template>
    <div class="supervisor-stats">
        <div class="statistic-container">
            <div class="statistic-block">
                <div class="statistic-head">Всего анкет</div>
                <div class="statistic-info">
                    <div class="row">
                        <div class="col-md-6">
                            Сегодня
                        </div>
                        <div class="col-md-6 text-right">
                            {{ statistics.questionnaires_day || '-' }}
                        </div>
                    </div>
                </div>
                <div class="statistic-info">
                    <div class="row">
                        <div class="col-md-6">
                            За неделю
                        </div>
                        <div class="col-md-6 text-right">
                            {{ statistics.questionnaires_week || '-' }}
                        </div>
                    </div>
                </div>
                <div class="statistic-info">
                    <div class="row">
                        <div class="col-md-6">
                            За месяц
                        </div>
                        <div class="col-md-6 text-right">
                            {{ statistics.questionnaires_month || '-' }}
                        </div>
                    </div>
                </div>
                <div class="statistic-info">
                    <div class="row">
                        <div class="col-md-6">
                            За год
                        </div>
                        <div class="col-md-6 text-right">
                            {{ statistics.questionnaires_year || '-' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="statistic-container">
            <div class="statistic-block">
                <div class="statistic-head">Среднее количество осмотров</div>
                <div class="statistic-info">
                    <div class="row">
                        <div class="col-md-6">
                            За день
                        </div>
                        <div class="col-md-6 text-right">
                            {{ statistics.inspections_day || '-' }}
                        </div>
                    </div>
                </div>
                <div class="statistic-info">
                    <div class="row">
                        <div class="col-md-6">
                            За неделю
                        </div>
                        <div class="col-md-6 text-right">
                            {{ statistics.inspections_week || '-' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="statistic-container">
            <div class="statistic-block">
                <div class="statistic-head">
                    Среднее время осмотра
                </div>
                <div class="statistic-info">
                    <div class="row">
                        <div class="col-md-6">
                            Минуты
                        </div>
                        <div class="col-md-6 text-right">
                            {{ statistics.inspection_average || '-' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="clear:both"></div>
    </div>
</template>
<script>
  import axios from 'axios'
  import _ from 'lodash'

  export default {
    data () {
      return {
        statistics: {},
      }
    },
    asyncComputed: {
    },
    methods: {
    },
    created () {
      axios.get('/api/statistics/dashboard')
        .then(({data}) => {
          this.statistics = data;
        })
        .catch(e => {
          alert('Не удалось загрузить статистику');
        });
    }
  }
</script>



// WEBPACK FOOTER //
// StatisticSupervisor.vue?7ac45ef0